import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { Button, IconButton } from '@mui/material';
import dayjs from 'dayjs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

import Facture from '../../../Components/Docs/Facture';
import FactureG from '../../../Components/Docs/FactureG';
import { buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import ChangeStatusPaymentFacture from '../../../Components/shared/ChangeStatusPaymentFacture';
import { MaterialTableComponent, TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import {StatutFacture, statutPaiementEnum } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import usePostRequest from '../../../hooks/usePostRequest';
import useUtilities from '../../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { getLastWorkingDayOfMonth } from '../../../Utils/getCalendarMonthMatrix';
import { extractYearAndMonth, getNomPrenomClearFromPersoData, isFactureG, isHttpStatusSuccess, searchLabelInEnumByValue, sortDate, UpperCasePrenomNom} from '../../../Utils/utils';
import { getMargeBrute, getMargeNet, getMontatantTTC } from '../../../Utils/utilsCraX';
import HeaderAllFacture from '../../Expert/Mission/HeaderAllFacture';
import { MenuButtonOptionsGenerateFacture } from './MenuButtonOptionsGenerateFacture';

const AllFacturesBackOffice = () => {
    const { addEuro4Decimal } = useNumberFormatting();

    const { setBackdropOpen, setSnackBarMessage,setIsSnackBarError, setOpenSnackBar} = useUtilities();
    const axiosPrivate = useAxiosPrivate();
    const { postData } = usePostRequest();

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [url, setUrl] = useState('');
    const [filtreFactureExpertNonPaye, setFiltreFactureExpertNonPaye] = useState(searchParams.get('filtreFactureExpertNonPaye') === 'true');
    const [filtreFactureClientNonPaye, setFiltreFactureClientNonPaye] = useState(searchParams.get('filtreFactureClientNonPaye') === 'true');
    const { i18n } = useTranslation();
    const [factureRows, setFactureRows] = useState([]);
    const [selectedFactures, setSelectedFactures] = useState([]);

    const [rowselected, setRowSelected] = useState();
    const [open, setOpen] = useState(false);
    const [openFactureG, setOpenFactureG] = useState(false);
    const [roleFacture,setRoleFacture]=useState('');
    const [chargeRecrutementId,setChargeRecrutementId]=useState('');
    const factureColumns4BackOffice = [
        {
            field: 'troisP',
            title: i18n.t('Options'),
            render: (rowData) => (
                <MenuButtonOptionsGenerateFacture
                    facture={rowData}
                    refreshFactures={()=>{getAllFactures(chargeRecrutementId);}}
                />
            ),
        },
        {
            field: 'periode',
            title: i18n.t('Période'),
            //render:  rowData =>
            //    searchLabelInEnumByValue(MonthsString,(rowData?.periode)),
        },
        {
            field: 'refFactureClient',
            title: i18n.t('Réf.Facture/Client'),
            render:  rowData => (
                <Button
                    variant='text'
                    onClick={()=> {
                        Promise.resolve().then(() => {
                            setRowSelected(rowData);
                            setRoleFacture('client');
                        }).then(() =>{
                            console.log('isFactureG(rowData.refFacture)',isFactureG(rowData.refFacture));
                            if(isFactureG(rowData.refFacture))
                                setOpenFactureG(true);
                            else
                                setOpen(true);
                        } );
                    }}
                >
                    {rowData?.refFactureClient}
                </Button>
            )
        },
        {
            field: 'dateEmission',
            title: i18n.t('Date d\'émission'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData.dateEmission),
        },
        {
            field: 'nomClient',
            title: i18n.t('Nom du Client/ESN'),
        },
        {
            field: 'nomExpert',
            title: i18n.t('Nom de l\'expert'),
        },
        {
            field: 'sourceExpert',
            title: i18n.t('Sce. Expert'),
        },
        {
            field: 'refIntClient',
            title: i18n.t('Réf.Int.Client'),
            render:  rowData => {
                {if(!isFactureG(rowData?.refFacture))
                    return(
                        <div style={{display:'flex',flexDirection:'row',gap:'10px',width:'230px'}}>
                            <TextFieldComponent
                                value={rowData?.refIntClient}
                                disabled
                                style={{width:'95%'}}
                            />
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={(event) =>EditRefIntClient(rowData,event)}
                                aria-label="close"
                            >
                                {rowData?.refIntClient ? <EditIcon /> : <AddIcon />}
                            </IconButton>
                        </div>
                    );
                }
            }
        },

        {
            field: 'intituleMission',
            title: i18n.t('Intitulé de la mission'),
        },

        {
            field: 'nbJour',
            title: i18n.t('Nb de jours'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.nbJour,'j');
            }
        },
        {
            field: 'tjClientHt',
            title: i18n.t('TJ Client HT'),
            render:  rowData =>
                addEuro4Decimal(rowData.tjClientHt)
        },
        {
            field: 'totalHTClient',
            title: i18n.t('Total HT/Client'),
            render:  rowData =>{
                return addEuro4Decimal(rowData.totalHTClient);
            }
        },
        {
            field: 'totalTTCClient',
            title: i18n.t('Total TTC/Client'),
            render:  rowData =>{
                if(isFactureG(rowData?.refFacture))
                    return addEuro4Decimal(rowData?.totalTTCClient);
                return addEuro4Decimal(getMontatantTTC(rowData.totalHTClient,rowData.tvaClient));
            }
        },
        {
            field: 'totalHnoClient',
            title: i18n.t('Total HNO Client'),
            render:  rowData =>{
                return addEuro4Decimal(rowData.totalHnoClient);
            }
        },
        {
            field: 'totalAstreinteClient',
            title: i18n.t('Total astreintes Client'),
            render:  rowData =>{
                return addEuro4Decimal(rowData.totalAstreinteClient);
            }
        },

        {
            field: 'totNotesFrais',
            title: i18n.t('Total notes de frais'),
            render:  rowData =>{
                return addEuro4Decimal(rowData.totNotesFrais);
            }
        },
        {
            field: 'dateEcheance',
            title: i18n.t('Date d\'échéance'),
        },
        {
            field: 'Statut',
            title: i18n.t('Statut Facture'),
            render:  rowData =>
                i18n.t(searchLabelInEnumByValue(StatutFacture,rowData?.Statut)),
        },
        {
            field: 'refCra',
            title: i18n.t('Réf.CRA'),
        },

        {
            field: 'dateValidationCra',
            title: i18n.t('Date de validation CRA'),
        },
        {
            field: 'refClient',
            title: i18n.t('Réf. Client'),
        },
        {
            field: 'delaiPaiement',
            title: i18n.t('Délai Paiement'),
        },
        {
            field: 'statutPaiementClient',
            title: i18n.t('Statut Paiement/Client'),
            render:  rowData =>
            {
                if(rowData?.Statut!='groupe'){
                    return (
                        <ChangeStatusPaymentFacture
                            width={'100%'}
                            facture={rowData}
                            whoPays={'client'}
                            getAllFacturesRefresh={()=>{getAllFactures(chargeRecrutementId);}}
                        />);
                }
            }
        },
        {
            field: 'datePaiementClient',
            title: i18n.t('Date Paiement/Client'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.datePaiementClient)
        },
        {
            field: 'refExpert',
            title: i18n.t('Réf. Expert'),
        },
        {
            field: 'refFactureExpert',
            title: i18n.t('Réf.Facture/Expert'),
            render:  rowData => {
                {
                    if(!isFactureG(rowData?.refFacture)){
                        return (
                            <Button
                                variant='text'
                                onClick={()=> {
                                    Promise.resolve().then(() => {
                                        setRowSelected(rowData);
                                        setRoleFacture('expert');
                                    }).then(() =>{
                                        console.log('isFactureG(rowData.refFacture)',isFactureG(rowData.refFacture));
                                        if(isFactureG(rowData.refFacture))
                                            setOpenFactureG(true);
                                        else
                                            setOpen(true);
                                    } );
                                }}
                            >
                                {rowData?.refFactureExpert}
                            </Button>
                        );
                    }
                }
            }
        },
        {
            field: 'tjExpert',
            title: i18n.t('TJ Expert'),
            render:  rowData =>{
                return addEuro4Decimal(rowData.tjExpert);
            }
        },
        {
            field: 'totalHTExpert',
            title: i18n.t('Total HT/Expert'),
            render:  rowData =>{
                return addEuro4Decimal(rowData.totalHTExpert);
            }

        },
        {
            field: 'totalHnoExpert',
            title: i18n.t('Total HNO Expert'),
            render:  rowData =>{
                return addEuro4Decimal(rowData.totalHnoExpert);
            }
        },
        {
            field: 'totalAstreinte',
            title: i18n.t('Total astreintes Expert'),
            render:  rowData =>{
                return addEuro4Decimal(rowData.totalAstreinte);
            }
        },
        {
            field: 'totalTTCExpert',
            title: i18n.t('Total TTC/Expert'),
            render: (rowData) => {
                //const montant = getMontatantTTC(rowData.totalHTExpert,rowData.tvaExpert);
                //console.log('typeof montant',typeof montant);
                //if (typeof montant !== 'number' || isNaN(montant)) {
                //    return '';
                //}
                if(isFactureG(rowData?.refFacture))
                    return addEuro4Decimal(rowData?.totalTTCExpert);
                return addEuro4Decimal(getMontatantTTC(rowData.totalHTExpert,rowData.tvaExpert));
            }
        },
        {
            field: 'tvaExpert',
            title: i18n.t('TVA Expert'),
            render:  rowData =>{
                return addEuro4Decimal(rowData.tvaExpert,'%');
            }
        },
        {
            field: 'statutPaiementExpert',
            title: i18n.t('Statut Paiement/Expert'),
            render:  rowData =>{
                if(!isFactureG(rowData?.refFacture)){
                    return (
                        <ChangeStatusPaymentFacture
                            width={'100%'}
                            facture={rowData}
                            whoPays={'expert'}
                            getAllFacturesRefresh={()=>{getAllFactures(chargeRecrutementId);}}
                        />
                    );
                }
            }
        },
        {
            field: 'datePaiementExpert',
            title: i18n.t('Date Paiement/Expert'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.datePaiementExpert)
        },
        {
            field: 'tvaClient',
            title: i18n.t('TVA Client'),
            render:  rowData =>{
                return addEuro4Decimal(rowData.tvaClient,'%');
            }
        },
        {
            field: 'margeBrut',
            title: i18n.t('Marge brute'),
            render: rowData =>{
                if(rowData?.margeBrut!='PC')
                    return addEuro4Decimal(rowData?.margeBrut);
                else
                    return rowData?.margeBrut;

            }
        },
        {
            field: 'margeNet',
            title: i18n.t('Marge nette'),
            render: rowData =>{
                if(rowData?.margeNet!='PC')
                    return addEuro4Decimal(rowData?.margeNet);
                else
                    return rowData?.margeNet;
            }
        },
        {
            field: 'respComptabilite',
            title: i18n.t('Resp.Comptabilité'),

        },
        {
            field: 'respOperationnel',
            title: i18n.t('Resp.Opérationnel'),

        },
        {
            field: 'respAchat',
            title: i18n.t('Resp.Achat'),

        },
        {
            field: 'chargeRecrutement',
            title: i18n.t('Chargé de recrutement'),
        },
    ];

    useEffect(() => {
        getMyInfos();
    }, [chargeRecrutementId]);

    useEffect(() => {
        const currentUrl = window.location.href;
        setUrl(currentUrl);
    }, [location]);

    useEffect(() => {
        console.log('factureRows',factureRows,'length',factureRows.length);
    }, [factureRows]);

    useEffect(() => {
        if(url && !url.toLowerCase().includes('filtrefactureexpertnonpaye') && !url.toLowerCase().includes('filtrefactureclientnonpaye')){
            setFiltreFactureExpertNonPaye(false);
            setFiltreFactureClientNonPaye(false);
        }
    }, [url]);

    useEffect(() => {
        getMyInfos();
    }, [filtreFactureClientNonPaye,filtreFactureExpertNonPaye]);

    console.log('setFiltreFactureClientNonPaye',filtreFactureClientNonPaye,'filtreFactureExpertNonPaye',filtreFactureExpertNonPaye);
    const getMyInfos = async () => {
        try {
            const response = await axiosPrivate.get('admin/getMyInfos');
            if((response.data?.backOffice?.roles?.chargeRecrutement==1)){
                setChargeRecrutementId(response.data?.backOffice?._id);
                await getAllFactures(response.data?.backOffice?._id);
            }
            else{
                setChargeRecrutementId('');
                await getAllFactures('');
            }

        } catch (error) {
            console.log(error);
        }
    };

    const EditRefIntClient= (rowData,e)=>{
        e.preventDefault();
        const textInputElement = document.createElement('input');
        textInputElement.setAttribute('type', 'text');
        textInputElement.setAttribute('id', 'text-input');
        textInputElement.setAttribute('value',rowData?.refIntClient);
        textInputElement.style.padding = '10px';
        textInputElement.style.border = '1px solid #ccc';
        textInputElement.style.borderRadius = '4px';
        textInputElement.style.fontSize = '16px';
        //textInputElement.style.width = '100%';
        textInputElement.style.fontFamily = 'Lato';
        let response1;
        textInputElement.value = rowData?.refIntClient ?? '';

        Swal.fire({
            title: i18n.t('Saisir la référence'),
            html:textInputElement,
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'Annuler',
            confirmButtonColor: '#5CC889',
            cancelButtonColor: '#88898f',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                try {
                    const referenceInput = document.getElementById('text-input').value;
                    console.log('Reference:', referenceInput);
                    if(!referenceInput || referenceInput == ''){
                        setSnackBarMessage(i18n.t('la référence est un champs requis'));
                        setIsSnackBarError(true);
                        setOpenSnackBar(true);
                    }
                    else{
                        response1 = await axiosPrivate.post('/facture/updateRefIntClient',
                            {
                                'refIntClient':referenceInput,
                                'type':`facture${isFactureG(rowData?.facture?.refFacture) ? 'G' : ''}`,
                                [rowData?.isCraOrCraX]: rowData?.[rowData?.isCraOrCraX]?._id, // we send craX or cra, and since oneCra has one facture .. so it's great for fraudes ..
                                factureGId: rowData?._id
                            }
                        );
                        const responseData1 = await response1.data;
                        console.log('submitresumeBackend', responseData1, responseData1?.message);
                    }
                }
                catch (error) {
                    console.log(error.response?.status);
                    Swal.fire({
                        icon: 'error',
                        title: i18n.t('Oops...'),
                        text: error.response.data?.error,
                        // footer: '<a href="">Why do I have this issue?</a>'
                    });
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            if(result.isConfirmed){
                if(chargeRecrutementId)
                    getAllFactures(chargeRecrutementId);
                else
                    getAllFactures('');
            }
            else if (result.dismiss === Swal.DismissReason.cancel){
                console.log('cancel');
            }
        });
    };
    function calculateTotals(facturesX) {
        let cumulAstreinteClient = 0;
        let cumulAstreinte = 0;
        let cumulHno = 0;
        let cumulHnoClient = 0;
        let noteFrais = 0;

        facturesX.map(item => {
            cumulAstreinteClient += (item?.totalAstreintesClient || 0);
            cumulAstreinte += (item?.totalAstreinte || 0);
            cumulHno += (item?.totalHnos || 0);
            cumulHnoClient += (item?.totalHnosClient || 0);
            noteFrais += (item?.totalNotesFrais || 0);
        });

        return {
            cumulAstreinteClient:cumulAstreinteClient,
            cumulAstreinte:cumulAstreinte,
            cumulHno:cumulHno,
            cumulHnoClient:cumulHnoClient,
            noteFrais:noteFrais
        };
    }

    function calculateMargeNetteBrutteFactureNormale(factures) {
        let totalClient = 0, totalExpert=0;
        factures.map(item => {
            totalClient += (item?.craId?.montantTotalClient || item?.craId?.tjClient * item?.craId?.nbrDays);
            totalExpert += (item?.craId?.montantTotal || item?.craId?.tj * item?.craId?.nbrDays);
        });

        return {
            totalClient:totalClient,
            totalExpert:totalExpert,
        };
    }

    const mapFactures = (facture) => {
        const isCraOrCraX = facture?.craId?.nbrDays ? 'craId' : 'craXId';
        // console.log('facture',facture,'total note frais ',facture?.craXId?.totalNotesFrais);
        const totalHtClient=facture?.[isCraOrCraX]?.nbrDays ?(facture?.[isCraOrCraX]?.nbrDays * facture?.[isCraOrCraX]?.tjClient): facture?.[isCraOrCraX]?.montantTotalClient;
        const totalHtExpert=facture?.[isCraOrCraX]?.nbrDays ?(facture?.[isCraOrCraX]?.nbrDays * facture?.[isCraOrCraX]?.tj): facture?.[isCraOrCraX]?.montantTotal;
        return {
            isCraOrCraX: isCraOrCraX,
            'id': facture?._id,
            //'refFactureClient': facture?.craId?.nbrDays ? facture?.factureId : facture?.factureXId,
            'refFactureClient': facture?.refFacture ? ((facture?.statutFacture =='groupe' ||facture?.statutFactureX=='groupe') ? 'P'+facture?.refFacture: facture?.refFacture) :'Proforma client',
            'refFactureExpert':facture?.refFacture ? facture?.refFacture + 'E' :'Proforma expert' ,
            'margeNet':isCraOrCraX=='craXId' ? 'PC' :getMargeNet(getMargeBrute(totalHtClient, totalHtExpert),totalHtClient),
            'margeBrut':isCraOrCraX=='craXId' ? 'PC' : getMargeBrute(totalHtClient, totalHtExpert),
            //'refFactureExpert': facture?.craId?.nbrDays ? facture?.factureId + 'E' : facture?.factureXId + 'E',
            'refCra': facture?.[isCraOrCraX]?.[isCraOrCraX],
            'refClient': facture?.[isCraOrCraX]?.missionId?.companyDataId?.clientId ?? facture?.[isCraOrCraX]?.missionId?.esnId?.esnId,
            'nomClient': facture?.[isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.nom ?? facture?.[isCraOrCraX]?.missionId?.esnId?.profileEntreprise?.nom,
            'refExpert': facture?.[isCraOrCraX]?.missionId?.expertId?.expertId,
            'nomExpert': UpperCasePrenomNom(facture?.[isCraOrCraX]?.missionId?.expertId?.persoData),
            'intituleMission': facture?.[isCraOrCraX]?.missionId?.titre,
            'refIntClient':facture?.refIntClient,
            //'dateValidationCra': Date(facture?.[isCraOrCraX]?.DateVC) > Date(facture?.[isCraOrCraX]?.DateVE) ? formatDateJJMMYYYY(facture?.[isCraOrCraX]?.DateVC) : formatDateJJMMYYYY(facture?.[isCraOrCraX]?.DateVE),
            'dateValidationCra': formatDateJJMMYYYY(facture?.[isCraOrCraX]?.DateVC),
            'dateEmission': formatDateJJMMYYYY(facture?.dateEmission),
            //'dateFacturation':formatDateJJMMYYYY(moment(getLastWorkingDayOfMonth(
            //    dayjs(new Date(facture?.[isCraOrCraX]?.year, facture?.[isCraOrCraX]?.month-1)).locale('fr').format('YYYY'),
            //    dayjs(new Date(facture?.[isCraOrCraX]?.year, facture?.[isCraOrCraX]?.month-1)).locale('fr').format('MM'),
            //    (facture?.[isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.localisation?.split('/')?.pop()||'fr')))),
            'Statut': facture?.craId?.nbrDays ? facture?.statutFacture : facture?.statutFactureX,
            'periode':dayjs(new Date(facture?.[isCraOrCraX]?.year, facture?.[isCraOrCraX]?.month-1)).locale('fr').format('MMMM YYYY'),
            'sourceExpert':facture?.[isCraOrCraX]?.missionId?.esnExpertOwnerId ? facture?.[isCraOrCraX]?.missionId?.esnExpertOwnerId?.profileEntreprise?.nom :'Freelance',
            'dateEcheance':formatDateJJMMYYYY(moment(getLastWorkingDayOfMonth(
                dayjs(new Date(facture?.[isCraOrCraX]?.year, facture?.[isCraOrCraX]?.month-1)).locale('fr').format('YYYY'),
                dayjs(new Date(facture?.[isCraOrCraX]?.year, facture?.[isCraOrCraX]?.month-1)).locale('fr').format('MM'),
                ((facture?.[isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.localisation?.split('/')?.pop() ??
                facture?.[isCraOrCraX]?.missionId?.profileEntreprise?.localisation?.split('/')?.pop())||'fr'))).add('days',facture?.delaiPaiement)),
            'dateFacturation':formatDateJJMMYYYY(moment(getLastWorkingDayOfMonth(
                dayjs(new Date(facture?.[isCraOrCraX]?.year, facture?.[isCraOrCraX]?.month-1)).locale('fr').format('YYYY'),
                dayjs(new Date(facture?.[isCraOrCraX]?.year, facture?.[isCraOrCraX]?.month-1)).locale('fr').format('MM'),
                ((facture?.[isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.localisation?.split('/')?.pop() ??
                facture?.[isCraOrCraX]?.missionId?.profileEntreprise?.localisation?.split('/')?.pop())||'fr')))),
            'statutPaiementExpert':i18n.t(searchLabelInEnumByValue(statutPaiementEnum,facture?.statutPaimentExpert)),
            'statutPaiementClient':i18n.t(searchLabelInEnumByValue(statutPaiementEnum,facture?.statutPaimentClient)),
            'datePaiementClient':facture?.datePaimentClient,
            'datePaiementExpert':facture?.datePaimentExpert,
            'nbJour': facture?.nbrUnite,
            'tjClientHt':facture?.[isCraOrCraX]?.tjClient,
            'tjExpert':facture?.[isCraOrCraX]?.tj,
            'tvaExpert':facture?.tva ?? facture?.craXId?.missionId?.esnExpertOwnerId?.donneeFacturation?.tauxTva ?? facture?.craXId?.missionId?.expertId?.entreprise?.tauxTva,
            'tvaClient':facture?.tvaClient ?? facture?.craXId?.missionId?.esnId?.donneeFacturation?.tauxTva ?? facture?.craXId?.missionId?.companyDataId?.donneeFacturation?.tauxTva,
            'hnos':facture?.[isCraOrCraX]?.hnos,
            'astreintes':facture?.[isCraOrCraX]?.astreintes,
            'notesFrais':facture?.[isCraOrCraX]?.notesFrais,
            'Date':facture?.dateEmission,
            'totalAstreinte':facture?.craXId?.totalAstreintes,
            'totalAstreinteClient':facture?.craXId?.totalAstreintesClient,
            'totalHnoClient':facture?.craXId?.totalHnosClient,
            'totalHnoExpert': facture?.craXId?.totalHnos,
            'totNotesFrais': facture?.craXId?.totalNotesFrais,
            'totalHTExpert':totalHtExpert,
            'totalHTClient':totalHtClient,
            'respComptabilite':getNomPrenomClearFromPersoData(facture?.[isCraOrCraX]?.bdcId?.responsableComptabiliteId?.persoData ?? facture?.[isCraOrCraX]?.bdcId?.responsableComptabiliteEsnExpertId?.persoData),
            'respOperationnel':getNomPrenomClearFromPersoData(facture?.[isCraOrCraX]?.bdcId?.responsableOperationnelId?.persoData ?? facture?.[isCraOrCraX]?.bdcId?.responsableOperationnelEsnId?.persoData),
            'respAchat':getNomPrenomClearFromPersoData(facture?.[isCraOrCraX]?.bdcId?.responsableAchatId?.persoData ?? facture?.[isCraOrCraX]?.bdcId?.responsableAchatEsnId?.persoData),
            'chargeRecrutement':getNomPrenomClearFromPersoData(facture?.[isCraOrCraX]?.bdcId?.backOfficeId?.persoData),
            // 'totalTva':
            ...facture
            // Add other properties as needed...
        };

    };

    const mapFacturesG = (facture) => {
        const factureG = facture?.factures?.length >0 ? facture?.factures[0]?.['craId'] : facture?.facturesX[0]?.['craXId'];
        let totals=calculateTotals(facture?.facturesX);
        const periodeFactureG = extractYearAndMonth(facture?.refFacture);
        return {
            'id': facture?._id,
            'refFactureClient': facture?.refFacture,
            'refFactureExpert': facture?.refFacture + 'E',
            'refCra': '--',
            'refClient': facture?.companyDataId?.clientId,
            'nomClient': facture?.companyDataId?.profileEntreprise?.nom,
            'refExpert': '--',
            'nomExpert': '--',
            'intituleMission': '--',
            'refIntClient': facture?.refIntClient,
            'dateValidationCra': '--',
            'dateEmission': formatDateJJMMYYYY(facture?.dateEmission),
            'Statut':'groupeG',
            'margeBrut':facture?.facturesX.length>0 ? getMargeBrute(calculateMargeNetteBrutteFactureNormale(facture?.factures)?.totalClient,calculateMargeNetteBrutteFactureNormale(facture?.factures)?.totalExpert) : getMargeBrute(facture?.totalHtClient, facture?.totalHtExpert),
            'margeNet':facture?.facturesX.length>0 ? getMargeNet(getMargeBrute(calculateMargeNetteBrutteFactureNormale(facture?.factures)?.totalClient,calculateMargeNetteBrutteFactureNormale(facture?.factures)?.totalExpert),calculateMargeNetteBrutteFactureNormale(facture?.factures)?.totalClient) : getMargeNet(getMargeBrute(facture?.totalHtClient, facture?.totalHtExpert),facture?.totalHtClient),
            // ! recupere year and month
            'periode':dayjs(new Date(periodeFactureG?.year, periodeFactureG?.month-1)).locale('fr').format('MMMM YYYY'),
            'totalTTCClient':facture?.totalClient,
            'totalTTCExpert':facture?.totalExpert,
            'dateEcheance':formatDateJJMMYYYY(moment(getLastWorkingDayOfMonth(
                dayjs(new Date(periodeFactureG?.year,  periodeFactureG?.month-1)).locale('fr').format('YYYY'),
                dayjs(new Date(periodeFactureG?.year,  periodeFactureG?.month-1)).locale('fr').format('MM'),
                (facture?.companyDataId?.profileEntreprise?.localisation?.split('/')?.pop()||'fr'))).add('days',facture?.delaiPaiement)),
            'dateFacturation':formatDateJJMMYYYY(moment(getLastWorkingDayOfMonth(
                dayjs(new Date(periodeFactureG?.year,  periodeFactureG?.month-1)).locale('fr').format('YYYY'),
                dayjs(new Date(periodeFactureG?.year,  periodeFactureG?.month-1)).locale('fr').format('MM'),
                (facture?.companyDataId?.profileEntreprise?.localisation?.split('/')?.pop()||'fr')))),
            'statutPaiementExpert':i18n.t(searchLabelInEnumByValue(statutPaiementEnum,facture?.statutPaimentExpert)),
            'statutPaiementClient':i18n.t(searchLabelInEnumByValue(statutPaiementEnum,facture?.statutPaimentClient)),
            'datePaiementClient':facture?.datePaimentClient,
            'datePaiementExpert':facture?.datePaimentExpert,
            'nbJour': facture?.nbrUnite,
            'tjClientHt':'--',
            'tjExpert':'--',
            'tvaExpert':'--',
            'tvaClient':facture?.tvaClient,

            'hnos':'--',
            'astreintes':'--',
            'notesFrais':'--',
            'Date':facture?.dateEmission,
            'totalAstreinte':totals?.cumulAstreinte,
            'totalAstreinteClient':totals?.cumulAstreinteClient,
            'totalHnoClient':totals?.cumulHnoClient,
            'totalHnoExpert': totals?.cumulHno,
            'totNotesFrais': totals?.noteFrais,
            'totalHTExpert':facture?.totalHtExpert,
            'totalHTClient':facture?.totalHtClient,
            'respComptabilite':getNomPrenomClearFromPersoData(factureG?.bdcId?.responsableComptabiliteId?.persoData),
            'respOperationnel': '--', //getNomPrenomClearFromPersoData(factureG?.bdcId?.responsableOperationnelId?.persoData),
            'respAchat':getNomPrenomClearFromPersoData(factureG?.bdcId?.responsableAchatId?.persoData),
            'chargeRecrutement':getNomPrenomClearFromPersoData(factureG?.bdcId?.backOfficeId?.persoData),
            // 'totalTva':
            ...facture
            // Add other properties as needed...
        };

    };

    // const groupFacturesByRefFacture = (factures) => {
    //     let sortedFactures=[];
    //     factures.forEach(facture => {
    //         const refFacture = facture.refFactureClient;
    //         if ((!refFacture.endsWith('G') && !refFacture.startsWith('P')) || refFacture == 'Proforma client') {
    //             sortedFactures.push(facture);
    //         }
    //         else if(refFacture.endsWith('G')) {
    //             sortedFactures.push(facture);
    //             factures.forEach(subFactures => {
    //                 const refWithoutG = refFacture.slice(0, -1);
    //                 if (subFactures.refFactureClient.includes(refWithoutG) && subFactures.refFactureClient!==refFacture) {
    //                     sortedFactures.push(subFactures);
    //                 }
    //             });
    //         }
    //     });
    //     return sortedFactures;
    // };

    const groupFacturesByRefFacture = (factures) => {
        // Extract base reference function
        const extractBaseRef = (ref) => {
            let baseRef =ref;
            if(baseRef.startsWith('P'))
                baseRef = ref.replace(/^P/, ''); // Remove 'P' at the start
            if(baseRef.includes('XG'))
                baseRef = baseRef.replace(/XG-?\d*$/, ''); // Remove 'XG' and trailing digits at the end
            if(baseRef.includes('G'))
                baseRef = baseRef.replace(/G-?\d*$/, ''); // Remove 'G' and trailing digits at the end
            return baseRef;
        };

        // Sort factures by base reference
        factures.sort((a, b) => {
            const baseRefA = extractBaseRef(a.refFactureClient);
            const baseRefB = extractBaseRef(b.refFactureClient);
            return baseRefA.localeCompare(baseRefB);
        });

        return factures;
    };

    //=============================================================================
    const getAllFactures = async (chargeRecrutementId) => {
        setBackdropOpen(true);
        try {
            const response = await axiosPrivate.get('/facture/getAllFacture/', {
                // signal: controller.signal
            });
            console.log('RESPONSE', response);
            //?  if is mounted==true do next [setUsers..]
            // setFactures2(response.data.data)
            let listFacture = await response.data?.factures;
            let Array1=[];
            if(filtreFactureExpertNonPaye){
                Array1 = listFacture.reduce((acc, facture) => {
                    const isCraOrCraX = facture?.craId?.nbrDays ? 'craId' : 'craXId';
                    //const isFactureOrG = isFactureG(facture?.refFacture);
                    console.log('chargeRecrutementId',chargeRecrutementId,'BOID',facture?.[isCraOrCraX]?.bdcId?.backOfficeId?._id);
                    if(chargeRecrutementId && chargeRecrutementId==facture?.[isCraOrCraX]?.bdcId?.backOfficeId?._id)
                        if((facture?.statutFacture=='genere'||facture?.statutFacture=='groupe'||facture?.statutFactureX=='genere'||facture?.statutFactureX=='groupe')&&(facture?.statutPaimentExpert=='nonPaye'))
                            acc.push(mapFactures(facture));
                    if(chargeRecrutementId==''){
                        console.log('ref',facture?.refFacture,'facture',facture?.statutFacture,'factureS',facture?.statutFactureX,'status expert',facture?.statutPaimentExpert);
                        if((facture?.statutFacture=='genere'||facture?.statutFacture=='groupe'||facture?.statutFactureX=='genere'||facture?.statutFactureX=='groupe')&&(facture?.statutPaimentExpert=='nonPaye')){
                            console.log('ref',facture?.refFacture);
                            acc.push(mapFactures(facture));
                        }
                        // if(!isFactureOrG && facture?.statutPaimentExpert=='nonPaye')
                        //     acc.push(mapFacturesG(facture));
                    }

                    return acc;
                }, []);
            }
            else if(filtreFactureClientNonPaye){
                Array1 = listFacture.reduce((acc, facture) => {
                    const isCraOrCraX = facture?.craId?.nbrDays ? 'craId' : 'craXId';
                    console.log('facture?.refFacture',facture?.refFacture);
                    const isFactureOrG = isFactureG(facture?.refFacture);
                    if(chargeRecrutementId && chargeRecrutementId==facture?.[isCraOrCraX]?.bdcId?.backOfficeId?._id)
                        if((facture?.statutFacture=='genere'||facture?.statutFactureX=='genere')&&(facture?.statutPaimentClient=='nonPaye'))
                            acc.push(mapFactures(facture));
                    if(chargeRecrutementId==''){
                        if((facture?.statutFacture=='genere'||facture?.statutFactureX=='genere')&&(facture?.statutPaimentClient=='nonPaye'))
                            acc.push(mapFactures(facture));
                        if(isFactureOrG && facture?.statutPaimentClient=='nonPaye')
                            acc.push(mapFacturesG(facture));
                    }

                    return acc;
                }, []);
            }
            else{
                Array1 = listFacture.reduce((acc, facture) => {
                    const isCraOrCraX = facture?.craId?.nbrDays ? 'craId' : 'craXId';
                    const isFactureOrG = isFactureG(facture?.refFacture);
                    if(chargeRecrutementId && chargeRecrutementId==facture?.[isCraOrCraX]?.bdcId?.backOfficeId?._id)
                        acc.push(mapFactures(facture));
                    if(chargeRecrutementId==''){
                        if(isFactureOrG)
                            acc.push(mapFacturesG(facture));
                        else
                            acc.push(mapFactures(facture));
                    }

                    return acc;
                }, []);
            }
            console.log('before sort',Array1,'soort',groupFacturesByRefFacture(sortDate(Array1)));
            setFactureRows(groupFacturesByRefFacture(sortDate(Array1)).reverse());
        } catch (error) {
            console.log(error);
        }
        setBackdropOpen(false);
    };
    const [selectedRow, setSelectedRow] = React.useState(null);
    //===========================update date de validation de l'xpert et aussi le statut=========================================
    async function createFactureG() {
        let isValid = true;
        try {
            let factureIds = [], factureXIds=[], totalClient=0, totalExpert=0, totalHtClient=0, totalHtExpert=0;
            // selectedFactures.forEach((facture)=> {
            for (const facture of selectedFactures) {
                console.log(facture?.statutFacture , facture?.statutFactureX);
                if(facture?.statutFacture !== 'proformat' && facture?.statutFactureX !== 'proformat'){
                    setSnackBarMessage(i18n.t('Toutes les factures doivent avoir le statut proforma'));
                    setIsSnackBarError(true);
                    setOpenSnackBar(true);
                    isValid = false;
                    break;
                }
                if (facture?.statutFacture){
                    factureIds.push(facture?._id);
                }
                else if (facture?.statutFactureX){
                    factureXIds.push(facture?._id);
                }
                totalExpert +=  Number(facture?.totalHTExpert + facture?.totalHTExpert * (facture?.tvaExpert/100));
                totalClient += Number(facture?.totalHTClient + facture?.totalHTClient * (facture?.tvaClient/100));
                totalHtClient += facture?.totalHTClient;
                totalHtExpert += facture?.totalHTExpert;
            }
            console.log('isValid',isValid);
            if(isValid){
                const response = await postData({ url: '/facture/createFactureG',
                    payload: {
                        factureIds,
                        factureXIds,
                        totalClient,
                        totalExpert,
                        totalHtClient,
                        totalHtExpert
                    } });
                if (isHttpStatusSuccess(response?.responseStatus)) {
                    getAllFactures(chargeRecrutementId);
                }
            }
            else if (!isValid){
                throw new TypeError('Toutes les factures doivent avoir le statut proforma');
            }
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <>
            <div className='frame5Profile'>
                {i18n.t('Gestion des missions')} &gt;  <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Facturation')}</span>
            </div>
            <div className='HomeFrame'>
                <h4 className='titlesociete'>
                    {i18n.t('Factures')}
                </h4>
                <div style={{ justifyContent: 'flex-end', alignSelf: 'stretch', display: 'flex' }}>
                    <Button
                        variant="contained"
                        style={{ ...buttonStylesGreen((selectedFactures.length>1 ? false:true)) }}
                        onClick={() => {
                            Swal.fire({
                                html: '<p>Êtes-vous sûr de vouloir grouper et générer ces factures?</p>',//+`${facture?.Statut}`,
                                confirmButtonColor: '#5CC889',
                                cancelButtonColor: '#88898f',
                                cancelButtonText: 'Annuler',
                                confirmButtonText: 'Oui',
                                showCancelButton: true,
                                customClass: {
                                    cancelButton: 'my-cancel-button-class'
                                },
                                //confirmButtonText: 'Prestation complémentaire',
                                //cancelButtonText: 'Prestation normale',
                                // showCloseButton: true
                            }).then(async (result) => {
                                console.log(result);
                                if (result.isConfirmed) {
                                    await createFactureG();
                                }
                                if (result.isDismissed) {
                                    //pass
                                }
                            });
                        }}
                    > {i18n.t('Grouper et générer les Factures')}
                    </Button>
                </div>
                <HeaderAllFacture />
                <MaterialTableComponent
                    columns={factureColumns4BackOffice}
                    data={factureRows}
                    title={i18n.t('Factures')}
                    options={{
                        selection: true,
                        selectionProps: rowData => ({
                            disabled: rowData.statutFacture ? rowData.statutFacture !== 'proformat' : rowData.statutFactureX !== 'proformat',
                            color: 'primary'
                        })
                    }}
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                    }}
                    selectedRow={selectedRow}
                    onSelectionChange={(rows) => {
                        setSelectedFactures(rows);
                    }}

                    // parentChildData={(row, rows) => rows.find(a => a?.id === row.parentId)}
                    // parentChildData={(row, rows) =>
                    // {
                    //     console.log({row, rows});
                    //     return rows.find(a => a?.id === row?.parentId);
                    // }
                    // }
                    //onRowClick={(e,rowData) => {
                    //    Promise.resolve().then(() => setRowSelected(rowData)).then(() => setOpen(true));
                    //    //setRowSelected(rowData).then(()=>
                    //    //    setOpen(true)
                    //    //);
                    //}}
                />
            </div>
            {open &&
            <Facture
                handleClose={()=>{
                    setOpen(false);
                }}
                facture={rowselected}
                open={open}
                role={roleFacture}
            />}

            {openFactureG &&
            <FactureG
                handleClose={()=>{
                    setOpenFactureG(false);
                }}
                facture={rowselected}
                open={openFactureG}
                role={roleFacture}
            />}
        </>
    );
};

export default AllFacturesBackOffice;
